import React, { useState, useRef, useEffect } from "react";
import {
  BrandContainer,
  ButtonNav,
  Container,
  Logo,
  NavbarContainer,
  NavContainer,
  SettingsButton,
  TextNav,
  UserAvatarContainer,
  UserContainer,
  UserName,
  UserDropdownContainer,
  UserDropdownContent,
  UserDropdownItem,
  UserDropdownDivider,
  UserAvatarCircle,
  UserAvatarLetter,
} from "./styles";
import { IoMdExit } from "react-icons/io";
import { FaUserCircle } from "react-icons/fa";
import {
  IoClose,
  IoCloseSharp,
  IoKey,
  IoLockClosed,
  IoSettingsSharp,
} from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../../AuthContext/AuthContext";
import { Modal, Box, TextField, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import userService from "../../services/UserService";
import { User } from "../../AuthContext/AuthContext";
import Button from "../../components/Button/button";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../shared/styles/global.styles";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import { Label } from "../Label/styles";
import InputComponent from "../Input/input";
import { Col } from "react-bootstrap";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [navSelected, setNavSelected] = React.useState<string>("Contribuintes");
  const { user, logout } = useAuth();
  const userPFP = true;
  const [openModal, setOpenModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const settingsDropdownRef = useRef<HTMLDivElement>(null);

  // Verificação de segurança antes de acessar as propriedades do usuário
  const currentUser = user as User;

  // Verifica se o currentUser é válido
  const userPermission = currentUser?.permission;

  // Função para verificar se o usuário tem permissão para acessar o Caixa
  // const hasCaixaAccess = () => {
  //   const hasAccess = userPermission === "admin" || userPermission === "cash";
  //   return hasAccess;
  // };

  const handleLogout = () => {
    Swal.fire({
      title: "Você realmente deseja sair?",
      text: "Você pode fazer login novamente a qualquer momento.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, sair!",
      cancelButtonText: "Não, cancelar",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate("/");
      }
    });
  };

  const handleLogoClick = () => {
    setNavSelected("Contribuintes"); // Define o estado como "Contribuintes"
    navigate("/list-contribuinte");
  };

  const handleNav = (nav: string) => {
    switch (nav) {
      case "Consulta rápida":
        navigate("/consulta-rapida");
        break;
      case "Reajuste parcelas":
        navigate("/reajuste-parcelas");
        break;

      case "Cadastros gerais":
        navigate("/cadastros-gerais");
        break;
      case "Contribuintes":
        navigate("/list-contribuinte");
        break;
      case "Usuários":
        navigate("/list-users");
        break;
      case "Locais de pagamento":
        navigate("/local-pagamento");
        break;
      case "Lotação":
        navigate("/lotacao");
        break;
      case "Caixa":
        navigate("/caixa");
        break;
      case "Remessas":
        navigate("/remessas");
        break;
      case "Relatórios":
        navigate("/relatorios-gerenciais");
        break;

      default:
        break;
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
    setShowErrors(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setShowErrors(false);
  };

  const handleChangePassword = async () => {
    setShowErrors(true);

    // Validação dos campos vazios
    if (
      !currentPassword.trim() ||
      !newPassword.trim() ||
      !confirmPassword.trim()
    ) {
      return;
    }

    const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");

    // Tenta pegar o ID e garante que seja um número válido
    let userId = currentUser?.id;
    if (!userId || isNaN(userId)) {
      userId = Number(storedUser.id);
    }

    if (!userId || isNaN(userId)) {
      console.error("No valid user ID found");
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro de autenticação. Por favor, faça login novamente.",
        allowOutsideClick: false,
      });
      logout(); // Força o logout se não houver ID válido
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "As senhas não coincidem!",
        allowOutsideClick: false,
      });
      return;
    }

    if (newPassword.length < 6) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "A nova senha deve ter pelo menos 6 caracteres!",
        allowOutsideClick: false,
      });
      return;
    }

    try {
      await userService.changePassword(userId, currentPassword, newPassword);

      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: "Senha alterada com sucesso!",
        allowOutsideClick: false,
      });
      handleCloseModal();
    } catch (error: any) {
      console.error("Password change error:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        allowOutsideClick: false,
        text:
          error.response?.data?.message ||
          "Erro ao alterar a senha. Verifique se a senha atual está correta.",
      });
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  // Mapeia as rotas para os nomes exibidos no Navbar
  const routeMap: Record<string, string> = {
    "/list-contribuinte": "Contribuintes",
    "/list-users": "Usuários",
    "/local-pagamento": "Locais de pagamento",
    "/lotacao": "Lotação",
    "/caixa": "Caixa",
    "/remessas": "Remessas",
    "/relatorios-gerenciais": "Relatórios",
    "/consulta-rapida": "Consulta rápida",
    "/reajuste-parcelas": "Reajuste parcelas",
    "/cadastros-gerais": "Cadastros gerais",
  };

  // Atualiza o item selecionado no Navbar ao mudar a rota
  // Garante o item correto mesmo após recarregar a página
  useEffect(() => {
    const selected = routeMap[location.pathname];
    if (selected) {
      setNavSelected(selected);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
      if (
        settingsDropdownRef.current &&
        !settingsDropdownRef.current.contains(event.target as Node)
      ) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Se currentUser ou userPermission estiver faltando, não renderize a navbar
  if (!currentUser || !userPermission) {
    return null; // Ou pode exibir um carregamento ou redirecionar para login
  }

  return (
    <NavbarContainer>
      <Container>
        <BrandContainer>
          <Logo
            alt="Santa Casa Logo"
            src={require("../../assets/logo-Santa-Casa-Cunha.webp")}
          />
        </BrandContainer>

        <NavContainer>
          {!!currentUser.controleAcesso?.some(
            (acesso) => acesso.modulos.nome === ModulosEnum.CONSULTA_RAPIDA
          ) && (
            <ButtonNav
              disabled={navSelected === "Consulta rápida"}
              onClick={() => {
                handleNav("Consulta rápida");
              }}
            >
              <TextNav active={navSelected === "Consulta rápida"}>
                Consulta rápida
              </TextNav>
            </ButtonNav>
          )}

          {!!currentUser.controleAcesso?.some(
            (acesso) => acesso.modulos.nome === ModulosEnum.CONTRIBUINTE
          ) && (
            <ButtonNav onClick={() => handleNav("Contribuintes")}>
              <TextNav
                active={navSelected === "Contribuintes"}
                cursor="pointer"
              >
                Contribuintes
              </TextNav>
            </ButtonNav>
          )}

          {!!currentUser.controleAcesso?.some(
            (acesso) =>
              acesso.modulos.nome === ModulosEnum.LOTACOES ||
              acesso.modulos.nome === ModulosEnum.LOCAL_PAGAMENTO ||
              acesso.modulos.nome === ModulosEnum.INSTRUCOES_BANCARIAS ||
              acesso.modulos.nome === ModulosEnum.FORMA_PAGAMENTO
          ) && (
            <ButtonNav onClick={() => handleNav("Cadastros gerais")}>
              <TextNav
                active={navSelected === "Cadastros gerais"}
                cursor="pointer"
              >
                Cadastros gerais
              </TextNav>
            </ButtonNav>
          )}

          {!!currentUser.controleAcesso?.some(
            (acesso) =>
              acesso.modulos.nome ===
                ModulosEnum.REAJUSTE_VALORES_FINANCEIROS &&
              acesso.permissoes.role.includes(PermissoesEnum.ESCRITA)
          ) && (
            <ButtonNav onClick={() => handleNav("Reajuste parcelas")}>
              <TextNav
                active={navSelected === "Reajuste parcelas"}
                cursor="pointer"
              >
                Reajuste + Parcelas
              </TextNav>
            </ButtonNav>
          )}

          {!!currentUser.controleAcesso?.some(
            (acesso) => acesso.modulos.nome === "CAIXA"
          ) && (
            <ButtonNav
              disabled={navSelected === "Caixa"}
              onClick={() => handleNav("Caixa")}
            >
              <TextNav active={navSelected === "Caixa"}>Caixa</TextNav>
            </ButtonNav>
          )}

          {!!currentUser.controleAcesso?.some(
            (acesso) =>
              acesso.modulos.nome === ModulosEnum.REMESSAS ||
              acesso.modulos.nome === ModulosEnum.RETORNOS
          ) && (
            <ButtonNav
              disabled={navSelected === "Remessas"}
              onClick={() => {
                handleNav("Remessas");
              }}
            >
              <TextNav active={navSelected === "Remessas"}>
                {!!currentUser.controleAcesso?.some(
                  (acesso) => acesso.modulos.nome === ModulosEnum.REMESSAS
                ) &&
                !!currentUser.controleAcesso?.some(
                  (acesso) => acesso.modulos.nome === ModulosEnum.RETORNOS
                )
                  ? "Remessas e Retornos"
                  : !!currentUser.controleAcesso?.some(
                      (acesso) => acesso.modulos.nome === ModulosEnum.REMESSAS
                    )
                  ? "Remessas"
                  : "Retornos"}
              </TextNav>
            </ButtonNav>
          )}
          {!!currentUser.controleAcesso?.some(
            (acesso) =>
              acesso.modulos.nome === ModulosEnum.RELATORIOS_GERENCIAIS
          ) && (
            <ButtonNav
              disabled={navSelected === "Relatórios"}
              onClick={() => {
                handleNav("Relatórios");
              }}
            >
              <TextNav active={navSelected === "Relatórios"}>
                Relatórios Gerenciais
              </TextNav>
            </ButtonNav>
          )}
          {!!currentUser.controleAcesso?.some(
            (acesso) => acesso.modulos.nome === ModulosEnum.USUARIOS
          ) && (
            <ButtonNav
              disabled={navSelected === "Usuários"}
              onClick={() => handleNav("Usuários")}
            >
              <TextNav active={navSelected === "Usuários"}>Usuários</TextNav>
            </ButtonNav>
          )}
        </NavContainer>

        <UserContainer>
          <UserAvatarContainer>
            {userPFP ? (
              <UserAvatarCircle onClick={() => setShowDropdown(!showDropdown)}>
                <UserAvatarLetter>{user?.name?.charAt(0)}</UserAvatarLetter>
              </UserAvatarCircle>
            ) : (
              <div style={{ position: "relative" }}>
                <FaUserCircle
                  size={55}
                  color="#4B5563"
                  onClick={() => setShowDropdown(!showDropdown)}
                  style={{ cursor: "pointer" }}
                />
                {showDropdown && (
                  <UserDropdownContent>
                    <UserDropdownItem
                      onClick={() => {
                        setShowDropdown(false);
                        handleOpenModal();
                      }}
                    >
                      Alterar Senha
                    </UserDropdownItem>
                    <UserDropdownDivider />
                    <UserDropdownItem
                      onClick={() => {
                        setShowDropdown(false);
                        handleLogout();
                      }}
                    >
                      Sair
                    </UserDropdownItem>
                  </UserDropdownContent>
                )}
              </div>
            )}
          </UserAvatarContainer>

          <UserName>{user?.name}</UserName>
          {/* <UserDropdownContainer ref={settingsDropdownRef}>
            <SettingsButton
              onClick={() => setShowSettingsDropdown(!showSettingsDropdown)}
            >
              <IoSettingsSharp size={24} color="#4B5563" />
            </SettingsButton>
            {showSettingsDropdown && (
              <UserDropdownContent>
                <UserDropdownItem
                  onClick={() => {
                    setShowSettingsDropdown(false);
                    handleOpenModal();
                  }}
                >
                  Alterar Senha
                </UserDropdownItem>
                <UserDropdownDivider />
                {currentUser.controleAcesso?.some(
                  (acesso) =>
                    acesso.modulos.nome === ModulosEnum.FORMA_PAGAMENTO
                ) && (
                  <>
                    <UserDropdownItem
                      onClick={() => {
                        navigate("/forma-pagamento");
                        setNavSelected("");
                      }}
                    >
                      Formas de pagamento
                    </UserDropdownItem>
                    <UserDropdownDivider />
                  </>
                )}
                {currentUser.controleAcesso?.some(
                  (acesso) =>
                    acesso.modulos.nome === ModulosEnum.INSTRUCOES_BANCARIAS
                ) && (
                  <>
                    <UserDropdownItem
                      onClick={() => {
                        navigate("/instrucao-bancaria");
                        setNavSelected("");
                      }}
                    >
                      Instruções bancarias
                    </UserDropdownItem>
                    <UserDropdownDivider />
                  </>
                )}
                <UserDropdownItem
                  onClick={() => {
                    setShowSettingsDropdown(false);
                    handleLogout();
                  }}
                >
                  Sair
                </UserDropdownItem>
              </UserDropdownContent>
            )}
          </UserDropdownContainer> */}
          <SettingsButton
            onClick={() => {
              setShowSettingsDropdown(false);
              handleOpenModal();
            }}
          >
            <IoKey size={30} color="#4B5563" />
          </SettingsButton>
          <SettingsButton onClick={handleLogout}>
            <IoMdExit size={30} color="#4B5563" />
          </SettingsButton>
        </UserContainer>
      </Container>

      <ModalContainer show={openModal}>
        <ModalContent width={25}>
          <Button
            type="button"
            schemaButton="x-close"
            action={() => setOpenModal(false)}
            icon={<IoCloseSharp size={30} />}
            position="absolute"
            top={10}
            right={10}
          />
          <ModalHeader>
            <BlueTitle>Alterar Senha</BlueTitle>
          </ModalHeader>

          <ModalBody>
            <Col>
              <Label>Senha Atual</Label>
              <InputComponent
                type={showCurrentPassword ? "text" : "password"}
                name="currentPassword"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Senha Atual"
                color="black"
                iconRight={
                  showCurrentPassword ? <VisibilityOff /> : <Visibility />
                }
                onIconRightClick={() =>
                  setShowCurrentPassword(!showCurrentPassword)
                }
              />
            </Col>
            <Col>
              <Label>Nova Senha</Label>
              <InputComponent
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nova Senha"
                color="black"
                iconRight={showNewPassword ? <VisibilityOff /> : <Visibility />}
                onIconRightClick={() => setShowNewPassword(!showNewPassword)}
              />
            </Col>
            <Col>
              <Label>Confirmar Nova Senha</Label>
              <InputComponent
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirmar Nova Senha"
                color="black"
                iconRight={
                  showConfirmPassword ? <VisibilityOff /> : <Visibility />
                }
                onIconRightClick={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
              />
            </Col>
          </ModalBody>

          <ModalFooter>
            <Button schemaButton="out-primary" action={handleCloseModal}>
              Cancelar
            </Button>
            <Button schemaButton="full-primary" action={handleChangePassword}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
    </NavbarContainer>
  );
};

export default Navbar;
